webpackJsonp([10],{

/***/ 1519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__(1861);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "context", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a85f8d9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__(2153);
function injectStyle (ssrContext) {
  __webpack_require__(2141)
  __webpack_require__(2143)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a85f8d9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a85f8d9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(1545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(1553);
function injectStyle (ssrContext) {
  __webpack_require__(1551)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64c87b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Otwarte modale w kolejności otwierania. Esc zamyka tylko ostatni, żeby przy
// zagnieżdżonych modalach (np. wykres otwierany z modala szczegółów alarmów)
// nie zamykały się wszystkie naraz.
var openModals = [];

// Esc w otwartej liście vue-select / vue-multiselect zamyka samą listę; przy
// otwartym kalendarzu vue2-datepicker też nie ruszamy modala, żeby jednym
// klawiszem nie stracić wypełnionego formularza.
var OPEN_DROPDOWN = '.vs--open, .multiselect--active';
var OPEN_DATEPICKER = '.mx-datepicker-popup';

// Faza capture: sprawdzamy listy, zanim ich własna obsługa Esc je zamknie.
function onDocumentKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var topModal = openModals[openModals.length - 1];
    if (topModal == null) return;

    var target = event.target;
    if (target instanceof Element && target.closest(OPEN_DROPDOWN) != null) return;
    if (document.querySelector(OPEN_DATEPICKER) != null) return;

    topModal.$emit('close');
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: {
            immediate: true,
            handler: function handler(isOpen) {
                isOpen ? this.registerOpen() : this.unregisterOpen();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.unregisterOpen();
    },

    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    },
    methods: {
        registerOpen: function registerOpen() {
            if (openModals.includes(this)) return;
            openModals.push(this);
            if (openModals.length === 1) {
                document.addEventListener('keydown', onDocumentKeydown, true);
            }
        },
        unregisterOpen: function unregisterOpen() {
            var index = openModals.indexOf(this);
            if (index === -1) return;
            openModals.splice(index, 1);
            if (openModals.length === 0) {
                document.removeEventListener('keydown', onDocumentKeydown, true);
            }
        }
    }
});

/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ['onClick'],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    buttonClass: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    buttonDef: function buttonDef() {
      return this.buttonClass === '' ? 'my-button' : '' + this.buttonClass;
    }
  }
});

/***/ }),

/***/ 1546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1544);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1550);
function injectStyle (ssrContext) {
  __webpack_require__(1548)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-330662f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1549);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6de141c4", content, true, {});

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-330662f6]{position:fixed;z-index:110;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-330662f6]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex}.modal-content[data-v-330662f6]{margin:auto;background-color:#fefefe;border:unset;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-330662f6]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-330662f6]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-330662f6]:focus,.close[data-v-330662f6]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-330662f6]{max-width:30%}#mdiv[data-v-330662f6]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-330662f6]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-330662f6]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Modal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAGhB,YAAa,AACb,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AAKD,gCACI,YAAa,AACb,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AAKD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ","file":"Modal.vue","sourcesContent":["\n.modal[data-v-330662f6] {\n    position: fixed;\n    /* Nad paskiem górnym (.app-header, z-index 20) i mobilnym menu (99/100),\n       ale pod popupami doklejanymi do body (Syncfusion 1000, datepicker 2001). */\n    z-index: 110;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-330662f6] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n/* margin: auto zamiast align-items/justify-content: center — modal wyższy od\n   ekranu zaczyna się od góry i da się go przewinąć do nagłówka z krzyżykiem\n   (przy centrowaniu flexem jego górna część wystawała poza ekran). */\n.modal-content[data-v-330662f6] {\n    margin: auto;\n    background-color: #fefefe;\n    border: unset;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-330662f6] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-330662f6] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-330662f6]:hover,\n.close[data-v-330662f6]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-330662f6] {\n    max-width: 30%;\n}\n.modal-slot[data-v-330662f6] {\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-330662f6] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container"},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : '')+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1552);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("9f84328e", content, true, {});

/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".my-button[data-v-64c87b52]{background:transparent;outline:none;border:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Button.vue"],"names":[],"mappings":"AACA,4BACI,uBAAwB,AACxB,aAAc,AACd,WAAa,CAChB","file":"Button.vue","sourcesContent":["\n.my-button[data-v-64c87b52] {\n    background: transparent;\n    outline: none;\n    border: none;\n}\n.my-button[data-v-64c87b52]:hover {\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonDef,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t(_vm.title))+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1556:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1558), __esModule: true };

/***/ }),

/***/ 1558:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(960);
__webpack_require__(1559);
module.exports = __webpack_require__(105).Array.from;


/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(222);
var $export = __webpack_require__(183);
var toObject = __webpack_require__(954);
var call = __webpack_require__(965);
var isArrayIter = __webpack_require__(966);
var toLength = __webpack_require__(446);
var createProperty = __webpack_require__(1560);
var getIterFn = __webpack_require__(962);

$export($export.S + $export.F * !__webpack_require__(967)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(184);
var createDesc = __webpack_require__(447);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 1561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Button__ = __webpack_require__(1543);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        title: {
            type: String,
            required: false
        },
        text: {
            type: String,
            required: false,
            default: ''
        },
        alternativeDeleteText: {
            type: String,
            required: false,
            default: 'AreYouSureDelete'
        }
    },
    watch: {},
    methods: {
        confirm: function confirm() {
            this.$emit('confirm');
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    },
    computed: {},
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_0__components_Button__["a" /* default */]
    },
    mounted: function mounted() {},
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 1565:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 1566:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 1567:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1572), __esModule: true };

/***/ }),

/***/ 1572:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1573);
module.exports = __webpack_require__(105).Object.assign;


/***/ }),

/***/ 1573:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(183);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1574) });


/***/ }),

/***/ 1574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(154);
var getKeys = __webpack_require__(961);
var gOPS = __webpack_require__(1566);
var pIE = __webpack_require__(1565);
var toObject = __webpack_require__(954);
var IObject = __webpack_require__(968);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(444)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 1578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteConfirm_vue__ = __webpack_require__(1561);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_905c32ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteConfirm_vue__ = __webpack_require__(1581);
function injectStyle (ssrContext) {
  __webpack_require__(1579)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-905c32ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_905c32ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1579:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1580);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("727af110", content, true, {});

/***/ }),

/***/ 1580:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"DeleteConfirm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-5 pr-5"},[_c('p',{staticClass:"mb-0 pt-4",staticStyle:{"text-align":"center","font-weight":"600","font-size":"18px"}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.alternativeDeleteText)))]),_vm._v(" "),_c('div',{staticClass:"row d-flex justify-content-between pb-4 mt-4 ml-4 mr-4"},[_c('div',{staticClass:"col flex-grow pr-2"},[_c('Button',{attrs:{"title":_vm.$t('Cancel'),"buttonClass":"cancel-button semi-bold w-100"},on:{"onClick":_vm.cancel}})],1),_vm._v(" "),_c('div',{staticClass:"col flex-grow pl-2"},[_c('Button',{attrs:{"title":_vm.$t('Delete'),"buttonClass":"delete-button semi-bold w-100"},on:{"onClick":_vm.confirm}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      required: true,
      default: ''
    },
    placeholder: {
      type: String,
      default: null,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    inputClass: {
      type: String,
      required: false
    },
    titleClass: {
      type: String,
      default: '',
      required: false
    },
    maxLength: {
      type: Number,
      required: false,
      default: 100
    },
    valueType: {
      type: String,
      required: false
    },
    errorMode: {
      type: String,
      default: ''
    },
    onlyNumbersWithNegatives: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      this.myValue = newVal;
    }
  },
  data: function data() {
    return {
      myValue: this.value
    };
  },

  computed: {
    classDef: function classDef() {
      return this.errorMode === '' ? 'input pl-2  ' + this.inputClass : 'input pl-2 error ' + this.inputClass;
    },
    titleDef: function titleDef() {
      return this.titleClass === '' ? 'title mt-3' : this.titleClass + ' mt-3';
    }
  },
  methods: {
    onChange: function onChange(evt) {
      this.$emit("onChange", evt.target.value);
    }
  }
});

/***/ }),

/***/ 1601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Select',
    props: {
        selected: {},
        options: {},
        title: {},
        description: {},
        label: {},
        disabled: {},
        selectClass: {},
        errorMode: {
            type: String,
            default: ''
        },
        clearable: {
            default: true
        }
    },
    watch: {
        selected: function selected(newVal, oldVal) {
            this.selectedOption = newVal;
        },
        options: function options(newVal, oldVal) {
            this.optionsList = newVal;
        }
    },
    methods: {
        onChange: function onChange() {}
    },
    components: {},
    computed: {
        classDef: function classDef() {
            return this.errorMode === '' ? 'select ' + this.selectClass : 'error ' + this.selectClass;
        }
    },
    mounted: function mounted() {},
    data: function data() {
        return {
            selectedOption: this.selected,
            optionsList: this.options
        };
    },
    created: function created() {}
});

/***/ }),

/***/ 1603:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(451)('meta');
var isObject = __webpack_require__(186);
var has = __webpack_require__(223);
var setDesc = __webpack_require__(184).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(444)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1612:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(186);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 1616:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select_vue__ = __webpack_require__(1601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b0dfaff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select_vue__ = __webpack_require__(1662);
function injectStyle (ssrContext) {
  __webpack_require__(1658)
  __webpack_require__(1660)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b0dfaff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b0dfaff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextField_vue__ = __webpack_require__(1593);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e1491b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextField_vue__ = __webpack_require__(1623);
function injectStyle (ssrContext) {
  __webpack_require__(1619)
  __webpack_require__(1621)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e1491b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e1491b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1619:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1620);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("15b7d214", content, true, {});

/***/ }),

/***/ 1620:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "input:disabled{background:#f1f1f1}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/TextField.vue"],"names":[],"mappings":"AACA,eACE,kBAAoB,CACrB","file":"TextField.vue","sourcesContent":["\ninput:disabled {\n  background: #f1f1f1;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1621:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1622);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("08bb99e4", content, true, {});

/***/ }),

/***/ 1622:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".input[data-v-3e1491b2]{border-radius:5px;color:#000}input[data-v-3e1491b2]::-webkit-input-placeholder{color:#0095b2}input[data-v-3e1491b2]::-moz-placeholder{color:#0095b2}input[data-v-3e1491b2]::-ms-input-placeholder{color:#0095b2}input[data-v-3e1491b2]::placeholder{color:#0095b2}input[data-v-3e1491b2]::-webkit-inner-spin-button,input[data-v-3e1491b2]::-webkit-outer-spin-button{-webkit-appearance:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/TextField.vue"],"names":[],"mappings":"AACA,wBACE,kBAAmB,AACnB,UAAa,CACd,AACD,kDACE,aAAwB,CACzB,AACD,yCACE,aAAwB,CACzB,AACD,8CACE,aAAwB,CACzB,AACD,oCACE,aAAwB,CACzB,AACD,oGAEI,uBAAyB,CAC5B","file":"TextField.vue","sourcesContent":["\n.input[data-v-3e1491b2] {\n  border-radius: 5px;\n  color: black;\n}\ninput[data-v-3e1491b2]::-webkit-input-placeholder {\n  color: rgb(0, 149, 178);\n}\ninput[data-v-3e1491b2]::-moz-placeholder {\n  color: rgb(0, 149, 178);\n}\ninput[data-v-3e1491b2]::-ms-input-placeholder {\n  color: rgb(0, 149, 178);\n}\ninput[data-v-3e1491b2]::placeholder {\n  color: rgb(0, 149, 178);\n}\ninput[data-v-3e1491b2]::-webkit-outer-spin-button,\ninput[data-v-3e1491b2]::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{class:_vm.titleDef},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),((_vm.valueType)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myValue),expression:"myValue"}],class:_vm.classDef,attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxLength":_vm.maxLength,"oninput":"this.value = this.value.slice(0, this.maxLength)","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.myValue)?_vm._i(_vm.myValue,null)>-1:(_vm.myValue)},on:{"change":[function($event){var $$a=_vm.myValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.myValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.myValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.myValue=$$c}},_vm.onChange]}}):((_vm.valueType)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myValue),expression:"myValue"}],class:_vm.classDef,attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxLength":_vm.maxLength,"oninput":"this.value = this.value.slice(0, this.maxLength)","type":"radio"},domProps:{"checked":_vm._q(_vm.myValue,null)},on:{"change":[function($event){_vm.myValue=null},_vm.onChange]}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myValue),expression:"myValue"}],class:_vm.classDef,attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxLength":_vm.maxLength,"oninput":"this.value = this.value.slice(0, this.maxLength)","type":_vm.valueType},domProps:{"value":(_vm.myValue)},on:{"change":_vm.onChange,"input":function($event){if($event.target.composing){ return; }_vm.myValue=$event.target.value}}}),_vm._v(" "),(_vm.errorMode !== '')?_c('p',{staticClass:"error",staticStyle:{"font-size":"13px","border":"none","color":"rgb(218, 97, 97)"}},[_vm._v(_vm._s(_vm.errorMode))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1624:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1567);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 1654:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1655), __esModule: true };

/***/ }),

/***/ 1655:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1656);
module.exports = __webpack_require__(105).Object.keys;


/***/ }),

/***/ 1656:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(954);
var $keys = __webpack_require__(961);

__webpack_require__(1657)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ 1657:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(183);
var core = __webpack_require__(105);
var fails = __webpack_require__(444);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 1658:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1659);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("1f375ab7", content, true, {});

/***/ }),

/***/ 1659:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".v-select .dropdown-toggle .clear{margin-top:4px;color:#0095b2!important}.v-select .open-indicator:before{border-color:#0095b2!important}.v-select.disabled .dropdown-toggle input{background-color:transparent!important;cursor:default!important}.select,.select-error{border:1px solid #a3d4e0}.v-select.disabled .dropdown-toggle,.v-select.disabled .dropdown-toggle .clear,.v-select.disabled .dropdown-toggle input,.v-select.disabled .open-indicator,.v-select.disabled .selected-tag .close .form-control[disabled]{cursor:default!important}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Select.vue"],"names":[],"mappings":"AAiEA,kCAEI,eAAgB,AAChB,uBAA0B,CAC7B,AACD,iCACI,8BAAiC,CACpC,AACD,0CACI,uCAAyC,AACzC,wBAA2B,CAC9B,AASD,sBACI,wBAA0B,CAC7B,AACD,4NAMI,wBAA2B,CAC9B","file":"Select.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*.v-select .dropdown-toggle .clear { visibility: hidden; }*/\n.v-select .dropdown-toggle .clear\n{\n    margin-top: 4px;\n    color: #0095B2 !important;\n}\n.v-select .open-indicator:before {\n    border-color: #0095B2 !important;\n}\n.v-select.disabled .dropdown-toggle input {\n    background-color: transparent !important;\n    cursor: default !important;\n}\n/*\n.v-select .dropdown-toggle {\n  border: 1px solid #A3D4E0 !important;\n}\n*/\n.select-error {\n    border: 1px solid #A3D4E0;\n}\n.select {\n    border: 1px solid #A3D4E0;\n}\n.v-select.disabled .dropdown-toggle,\n.v-select.disabled .dropdown-toggle .clear,\n.v-select.disabled .dropdown-toggle input,\n.v-select.disabled .open-indicator,\n.v-select.disabled .selected-tag .close\n.form-control[disabled] {\n    cursor: default !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1660:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1661);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("fd1da36a", content, true, {});

/***/ }),

/***/ 1661:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".v-select[data-v-7b0dfaff]{width:100%;color:#000;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:5px;height:35px;font-size:14px;font-family:SourceSansProRegular,sans-serif!important}.title[data-v-7b0dfaff]{width:160px;font-family:SourceSansProSemiBold,sans-serif!important;font-weight:700;font-size:14px;margin:0}.desc[data-v-7b0dfaff]{font-style:italic;font-size:13px;color:#606b6c}.error[data-v-7b0dfaff]{font-weight:700}.v-select.disabled[data-v-7b0dfaff]{border:none!important}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Select.vue"],"names":[],"mappings":"AACA,2BACI,WAAY,AACZ,WAAa,AACb,8BAA+B,AACvB,sBAAuB,AAC/B,kBAAmB,AACnB,YAAa,AACb,eAAgB,AAChB,qDAA2D,CAC9D,AACD,wBACI,YAAa,AACb,uDAA4D,AAC5D,gBAAkB,AAClB,eAAgB,AAChB,QAAU,CACb,AACD,uBACI,kBAAmB,AACnB,eAAgB,AAChB,aAAyB,CAC5B,AACD,wBACI,eAAkB,CACrB,AACD,oCACI,qBAAwB,CAC3B","file":"Select.vue","sourcesContent":["\n.v-select[data-v-7b0dfaff] {\n    width: 100%;\n    color: black;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border-radius: 5px;\n    height: 35px;\n    font-size: 14px;\n    font-family: 'SourceSansProRegular', sans-serif !important;\n}\n.title[data-v-7b0dfaff] {\n    width: 160px;\n    font-family: 'SourceSansProSemiBold', sans-serif !important;\n    font-weight: bold;\n    font-size: 14px;\n    margin: 0;\n}\n.desc[data-v-7b0dfaff] {\n    font-style: italic;\n    font-size: 13px;\n    color: rgb(96, 107, 108);\n}\n.error[data-v-7b0dfaff] {\n    font-weight: bold;\n}\n.v-select.disabled[data-v-7b0dfaff] {\n    border: none !important;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),_c('v-select',{ref:"vselect",class:_vm.classDef,attrs:{"options":_vm.optionsList,"label":_vm.label,"onChange":function (value) { return this$1.$emit('onChange', value); },"disabled":_vm.disabled,"clearable":_vm.clearable},model:{value:(_vm.selectedOption),callback:function ($$v) {_vm.selectedOption=$$v},expression:"selectedOption"}}),_vm._v(" "),(_vm.errorMode === '')?_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._v(" "),(_vm.errorMode !== '')?_c('p',{staticClass:"error",staticStyle:{"font-size":"13px","font-weight":"bold","border":"none","color":"rgb(218, 97, 97)"}},[_vm._v(_vm._s(_vm.errorMode))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1663:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(224);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1688:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1689), __esModule: true };

/***/ }),

/***/ 1689:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(974);
__webpack_require__(960);
__webpack_require__(973);
__webpack_require__(1690);
__webpack_require__(1696);
__webpack_require__(1699);
__webpack_require__(1701);
module.exports = __webpack_require__(105).Set;


/***/ }),

/***/ 1690:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1691);
var validate = __webpack_require__(1612);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(1692)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ 1691:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(184).f;
var create = __webpack_require__(975);
var redefineAll = __webpack_require__(971);
var ctx = __webpack_require__(222);
var anInstance = __webpack_require__(970);
var forOf = __webpack_require__(964);
var $iterDefine = __webpack_require__(452);
var step = __webpack_require__(976);
var setSpecies = __webpack_require__(977);
var DESCRIPTORS = __webpack_require__(154);
var fastKey = __webpack_require__(1603).fastKey;
var validate = __webpack_require__(1612);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 1692:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(80);
var $export = __webpack_require__(183);
var meta = __webpack_require__(1603);
var fails = __webpack_require__(444);
var hide = __webpack_require__(155);
var redefineAll = __webpack_require__(971);
var forOf = __webpack_require__(964);
var anInstance = __webpack_require__(970);
var isObject = __webpack_require__(186);
var setToStringTag = __webpack_require__(298);
var dP = __webpack_require__(184).f;
var each = __webpack_require__(1693)(0);
var DESCRIPTORS = __webpack_require__(154);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 1693:
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(222);
var IObject = __webpack_require__(968);
var toObject = __webpack_require__(954);
var toLength = __webpack_require__(446);
var asc = __webpack_require__(1694);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 1694:
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1695);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 1695:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(186);
var isArray = __webpack_require__(1663);
var SPECIES = __webpack_require__(87)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 1696:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(183);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(1697)('Set') });


/***/ }),

/***/ 1697:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(453);
var from = __webpack_require__(1698);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ 1698:
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(964);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 1699:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(1700)('Set');


/***/ }),

/***/ 1700:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(183);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ 1701:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(1702)('Set');


/***/ }),

/***/ 1702:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(183);
var aFunction = __webpack_require__(225);
var ctx = __webpack_require__(222);
var forOf = __webpack_require__(964);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ 1732:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button_vue__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Select__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_api__ = __webpack_require__(952);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        userObj: {
            required: false,
            type: Object
        }
    },
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_4__Button_vue__["a" /* default */],
        Select: __WEBPACK_IMPORTED_MODULE_5__Select__["a" /* default */]
    },
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["b" /* CommandColumn */]]
    },
    data: function data() {
        return {
            user: {
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                role: 'User',
                accessToSystems: [],
                password: '',
                systemGroups: []
            },
            serverAddress: '',
            systems: [],
            groups: [],
            error: "",

            wrapSettings: { wrapMode: 'Content' },
            selectionOptions: { type: 'Multiple' },
            filterOptions: {
                type: 'Menu'
            },
            filterCheckbox: {
                type: "CheckBox"
            }
        };
    },

    computed: {
        access: function access() {
            return this.user.accessToSystems;
        },
        sysGroups: function sysGroups() {
            return this.user.systemGroups;
        }
    },
    methods: {
        getUser: function getUser() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var usr, userSystems, systemsIndex, _loop, i, x, groupsIndexes, groupnames, g, idx;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_86" /* getSystemsWithCountries */])();

                            case 2:
                                _this.systems = _context.sent;
                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_6__api_api__["_24" /* getExistingGroups */])();

                            case 5:
                                _this.groups = _context.sent;

                                if (!(_this.userObj == null)) {
                                    _context.next = 8;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 8:
                                _context.next = 10;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_89" /* getUserById */])(_this.userObj.id);

                            case 10:
                                usr = _context.sent;

                                _this.user.id = usr.id;
                                _this.user.firstName = usr.firstName;
                                _this.user.lastName = usr.lastName;
                                _this.user.email = usr.email;
                                _this.user.phoneNumber = usr.phone;
                                _this.user.role = usr.roles.length != 0 ? usr.roles[0] : '';
                                _this.user.accessToSystems = [];
                                _context.next = 20;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_92" /* getUserSystemById */])(_this.userObj.id);

                            case 20:
                                userSystems = _context.sent;
                                systemsIndex = [];

                                if (!(_this.user.role == 'Server')) {
                                    _context.next = 25;
                                    break;
                                }

                                _this.serverAddress = usr.cloudAddress;
                                return _context.abrupt('return');

                            case 25:
                                _loop = function _loop(i) {
                                    x = _this.systems.filter(function (m) {
                                        return m.id == userSystems.systems[i].id;
                                    });


                                    if (x != null && x.length > 0) {
                                        _this.user.accessToSystems.push(x[0]);

                                        for (var j = 0; j < _this.systems.length; j++) {
                                            if (_this.systems[j].id == x[0].id) {
                                                systemsIndex.push(j);
                                                break;
                                            }
                                        }
                                    }
                                };

                                // console.log({user: this.user, usr: usr, systems: userSystems})

                                for (i = 0; i < userSystems.systems.length; i++) {
                                    _loop(i);
                                }

                                _this.$refs.modal_grid.selectRows(systemsIndex);

                                groupsIndexes = [];
                                groupnames = _this.groups.map(function (x) {
                                    return x.name;
                                });

                                for (i = 0; i < userSystems.systemGroups.length; i++) {
                                    g = userSystems.systemGroups[i];
                                    idx = groupnames.indexOf(g.name);

                                    groupsIndexes.push(idx);
                                }

                                // console.log({systemGroups: userSystems.systemGroups, groupsIndexes, groupnames})

                                _this.$refs.groups_grid.selectRows(groupsIndexes);

                            case 32:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        groupsSelectionChanged: function groupsSelectionChanged() {
            this.user.systemGroups = [];
            this.user.systemGroups = this.$refs.groups_grid.getSelectedRecords();
            // console.log(this.user.systemGroups)
        },
        selectionChanged: function selectionChanged() {
            this.user.accessToSystems = [];
            this.user.accessToSystems = this.$refs.modal_grid.getSelectedRecords();
            // console.log(this.user.accessToSystems)
        },

        dataBound: function dataBound() {
            this.$refs.modal_grid.autoFitColumns();
        },
        save: function save() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var groups, newUser, serverData;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this2.userObj != null)) {
                                    _context2.next = 41;
                                    break;
                                }

                                _this2.user.surname = _this2.user.lastName;
                                _context2.prev = 2;
                                _context2.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_127" /* updateUserAccountData */])(_this2.user);

                            case 5:
                                _context2.next = 10;
                                break;

                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2['catch'](2);

                                _this2.processError(_context2.t0);

                            case 10:
                                if (!(_this2.user.role != 'Server')) {
                                    _context2.next = 30;
                                    break;
                                }

                                groups = _this2.user.systemGroups.map(function (x) {
                                    return x.name;
                                });
                                _context2.prev = 12;
                                _context2.next = 15;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["n" /* assignUserToGroups */])(_this2.user.id, groups);

                            case 15:
                                _context2.next = 20;
                                break;

                            case 17:
                                _context2.prev = 17;
                                _context2.t1 = _context2['catch'](12);

                                _this2.processError(_context2.t1);

                            case 20:
                                _context2.prev = 20;
                                _context2.next = 23;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_130" /* updateUserSystems */])({ id: _this2.user.id, systems: _this2.user.accessToSystems });

                            case 23:
                                _context2.next = 28;
                                break;

                            case 25:
                                _context2.prev = 25;
                                _context2.t2 = _context2['catch'](20);

                                _this2.processError(_context2.t2);

                            case 28:
                                _context2.next = 30;
                                break;

                            case 30:
                                _context2.prev = 30;
                                _context2.next = 33;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_129" /* updateUserRole */])(_this2.user.id, _this2.user.role);

                            case 33:
                                _context2.next = 38;
                                break;

                            case 35:
                                _context2.prev = 35;
                                _context2.t3 = _context2['catch'](30);

                                _this2.processError(_context2.t3);

                            case 38:

                                _this2.$emit("save");
                                _context2.next = 67;
                                break;

                            case 41:
                                _this2.error = '';
                                _context2.prev = 42;
                                _context2.next = 45;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_104" /* registerUser */])(_this2.user);

                            case 45:
                                newUser = _context2.sent;

                                if (!(newUser.data != undefined)) {
                                    _context2.next = 61;
                                    break;
                                }

                                if (!(_this2.user.role != 'Server')) {
                                    _context2.next = 54;
                                    break;
                                }

                                _context2.next = 50;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_130" /* updateUserSystems */])({ id: newUser.data.userId, systems: _this2.user.accessToSystems });

                            case 50:
                                _context2.next = 52;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["n" /* assignUserToGroups */])(newUser.data.userId, _this2.user.systemGroups.map(function (x) {
                                    return x.name;
                                }));

                            case 52:
                                _context2.next = 60;
                                break;

                            case 54:
                                _context2.next = 56;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["h" /* addServerConfiguration */])({
                                    name: _this2.user.firstName + ' ' + _this2.user.lastName,
                                    address: _this2.serverAddress
                                });

                            case 56:
                                serverData = _context2.sent;


                                console.dir(newUser);

                                _context2.next = 60;
                                return Object(__WEBPACK_IMPORTED_MODULE_6__api_api__["l" /* assignServerManager */])(serverData.id, newUser.data.userId);

                            case 60:

                                if (_this2.error == '') {
                                    _this2.$emit("save");
                                }

                            case 61:
                                _context2.next = 67;
                                break;

                            case 63:
                                _context2.prev = 63;
                                _context2.t4 = _context2['catch'](42);

                                console.dir(_context2.t4);
                                _this2.processError(_context2.t4);

                            case 67:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[2, 7], [12, 17], [20, 25], [30, 35], [42, 63]]);
            }))();
        },
        processError: function processError(error) {
            if (error.response.data[0] != undefined) {
                this.error = error.response.data[0].description;
            } else {
                // console.log({err: error.response})
                this.error = "";
                if (error.response.data.errors.Password != undefined) {
                    this.error = error.response.data.errors.Password[0];
                } else if (error.response.data.errors.Email != undefined) {
                    this.error = error.response.data.errors.Email[0];
                }
            }
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.getUser();

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1733:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Button__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(952);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['text', 'invitationId'],
  watch: {},
  methods: {
    confirm: function confirm() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.pinNumber == null || _this.pinNumber.length == 0)) {
                  _context.next = 4;
                  break;
                }

                _this.error = 'Required';
                _context.next = 7;
                break;

              case 4:
                _this.error = '';
                _context.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["t" /* deleteInvitations */])(_this.invitationId, _this.pinNumber).then(function (d) {
                  _this.$emit("confirm");
                }).catch(function (error) {
                  if (error.response.data != undefined) {
                    _this.error = error.response.data.error;
                  } else {
                    // console.log({ err: error.response })
                    _this.error = "";
                  }
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  },
  computed: {},
  components: {
    Button: __WEBPACK_IMPORTED_MODULE_2__components_Button__["a" /* default */]
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      pinNumber: '',
      error: ''
    };
  }
});

/***/ }),

/***/ 1788:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserModal_vue__ = __webpack_require__(1732);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ebaa8d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserModal_vue__ = __webpack_require__(1791);
function injectStyle (ssrContext) {
  __webpack_require__(1789)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9ebaa8d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ebaa8d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1789:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1790);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("5fa46ad4", content, true, {});

/***/ }),

/***/ 1790:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "h4[data-v-9ebaa8d6]{text-align:center;font-size:18px}.error[data-v-9ebaa8d6]{text-align:left!important;color:#fd8282;font-size:11px;font-weight:700;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important}#info-container[data-v-9ebaa8d6]{width:50%;padding:20px;background:#fff;border:1px solid #efefef;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0 0 20px rgba(0,0,0,.1);box-shadow:0 0 20px rgba(0,0,0,.1);border-radius:5px 0 0 5px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}#systems-container[data-v-9ebaa8d6]{width:50%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.gallery-container[data-v-9ebaa8d6]{background:#f9f9f9;-webkit-box-shadow:0 0 40px rgba(53,110,138,.25);box-shadow:0 0 40px rgba(53,110,138,.25);border-radius:5px}.info-field[data-v-9ebaa8d6]{border-bottom:1px solid #e9e9e9;margin-bottom:12px;margin-top:12px}.info-field-title[data-v-9ebaa8d6]{font-style:normal;font-weight:600;font-size:12px;line-height:16px;color:#272727;margin:0}.info-field-row[data-v-9ebaa8d6]{width:100%;margin:0;padding-bottom:5px}.info-field-value[data-v-9ebaa8d6]{font-style:normal;font-weight:400;font-size:12px;line-height:16px;color:#272727}.section-title[data-v-9ebaa8d6]{font-weight:700}input[type=email][data-v-9ebaa8d6],input[type=password][data-v-9ebaa8d6],input[type=text][data-v-9ebaa8d6]{border:none;width:100%}input[type=email][data-v-9ebaa8d6]:focus,input[type=password][data-v-9ebaa8d6]:focus,input[type=text][data-v-9ebaa8d6]:focus{border-bottom:1px solid #0095b2;outline:none}select[data-v-9ebaa8d6]{border:none;width:100%}select[data-v-9ebaa8d6]:focus{outline:none;border-bottom:1px solid #0095b2}option[data-v-9ebaa8d6]{padding:4px}option[data-v-9ebaa8d6]:checked{background:#347c93;color:#fff}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Users/UserModal.vue"],"names":[],"mappings":"AACA,oBACI,kBAAmB,AACnB,cAAgB,CACnB,AACD,wBACI,0BAA4B,AAC5B,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,2CAAgD,AAChD,4BAA8B,AAC9B,yBAA4B,CAC/B,AACD,iCACI,UAAW,AACX,aAAc,AAEd,gBAAoB,AACpB,yBAA0B,AAC1B,8BAA+B,AACvB,sBAAuB,AAC/B,2CAAoD,AAC5C,mCAA4C,AACpD,0BAA+B,AAE/B,yBAA0B,AAEtB,sBAAuB,AAEnB,8BAA+B,AACvC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAClC,AACD,oCACI,UAAW,AACX,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAEnC,AACD,oCACI,mBAAoB,AACpB,iDAA0D,AAClD,yCAAkD,AAC1D,iBAAmB,CACtB,AACD,6BACI,gCAAiC,AACjC,mBAAoB,AACpB,eAAiB,CACpB,AACD,mCACI,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAElB,cAAe,AACf,QAAU,CACb,AACD,iCACI,WAAY,AACZ,SAAU,AACV,kBAAoB,CACvB,AACD,mCACI,kBAAmB,AACnB,gBAAoB,AACpB,eAAgB,AAChB,iBAAkB,AAElB,aAAe,CAClB,AACD,gCACI,eAAkB,CACrB,AACD,2GACI,YAAa,AACb,UAAY,CACf,AACD,6HACI,gCAAiC,AACjC,YAAc,CACjB,AACD,wBACI,YAAa,AACb,UAAY,CACf,AACD,8BACI,aAAc,AACd,+BAAiC,CACpC,AACD,wBACI,WAAa,CAChB,AACD,gCACI,mBAAoB,AACpB,UAAa,CAChB","file":"UserModal.vue","sourcesContent":["\nh4[data-v-9ebaa8d6] {\n    text-align: center;\n    font-size: 18px;\n}\n.error[data-v-9ebaa8d6] {\n    text-align: left !important;\n    color: #FD8282;\n    font-size: 11px;\n    font-weight: bold;\n    font-family: 'Open Sans', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n}\n#info-container[data-v-9ebaa8d6] {\n    width: 50%;\n    padding: 20px;\n\n    background: #FFFFFF;\n    border: 1px solid #EFEFEF;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    border-radius: 5px 0px 0px 5px;\n\n    -webkit-box-pack: justify;\n\n        -ms-flex-pack: justify;\n\n            justify-content: space-between;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n#systems-container[data-v-9ebaa8d6] {\n    width: 50%;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    /* margin: auto; */\n}\n.gallery-container[data-v-9ebaa8d6] {\n    background: #F9F9F9;\n    -webkit-box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n            box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n    border-radius: 5px;\n}\n.info-field[data-v-9ebaa8d6] {\n    border-bottom: 1px solid #E9E9E9;\n    margin-bottom: 12px;\n    margin-top: 12px;\n}\n.info-field-title[data-v-9ebaa8d6] {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n    margin: 0;\n}\n.info-field-row[data-v-9ebaa8d6] {\n    width: 100%;\n    margin: 0;\n    padding-bottom: 5px;\n}\n.info-field-value[data-v-9ebaa8d6] {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n}\n.section-title[data-v-9ebaa8d6] {\n    font-weight: bold;\n}\ninput[type=text][data-v-9ebaa8d6], input[type=\"email\"][data-v-9ebaa8d6], input[type=\"password\"][data-v-9ebaa8d6] {\n    border: none;\n    width: 100%;\n}\ninput[type=text][data-v-9ebaa8d6]:focus, input[type=\"email\"][data-v-9ebaa8d6]:focus, input[type=\"password\"][data-v-9ebaa8d6]:focus {\n    border-bottom: 1px solid #0095b2;\n    outline: none;\n}\nselect[data-v-9ebaa8d6] {\n    border: none;\n    width: 100%;\n}\nselect[data-v-9ebaa8d6]:focus {\n    outline: none;\n    border-bottom: 1px solid #0095b2;\n}\noption[data-v-9ebaa8d6] {\n    padding: 4px;\n}\noption[data-v-9ebaa8d6]:checked {\n    background: #347C93;\n    color: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1791:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal grow gallery-container",staticStyle:{"min-width":"700px","width":"50vw","height":"70vh"}},[_c('div',{attrs:{"id":"info-container"}},[_c('div',[_c('p',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('USER_INFORMATION')))]),_vm._v(" "),_c('div',[_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Role')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.role),expression:"user.role"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.user, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((['User', 'PC', 'Service', 'Admin', 'Server']),function(role,index){return _c('option',{key:index},[_vm._v(_vm._s(role))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.user.role != 'Server' ? _vm.$t('FirstName') : _vm.$t('Name')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.firstName),expression:"user.firstName"}],attrs:{"type":"text","placeholder":_vm.user.role != 'Server' ? _vm.$t('FirstName') : _vm.$t('Name')},domProps:{"value":(_vm.user.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "firstName", $event.target.value)}}})])])]),_vm._v(" "),(_vm.user.role != 'Server')?_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Surname')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.lastName),expression:"user.lastName"}],attrs:{"type":"text","placeholder":_vm.$t('LastName')},domProps:{"value":(_vm.user.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "lastName", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),(_vm.user.role == 'Server')?_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Address')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serverAddress),expression:"serverAddress"}],attrs:{"type":"text","placeholder":_vm.$t('Address')},domProps:{"value":(_vm.serverAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.serverAddress=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Email')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],attrs:{"type":"email","placeholder":_vm.$t('Email'),"disabled":_vm.userObj != null ? true : false},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}})])])]),_vm._v(" "),(_vm.userObj == null)?_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Password')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],attrs:{"type":"password","placeholder":_vm.$t('Password')},domProps:{"value":(_vm.user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),(_vm.user.role != 'Server')?_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('PhoneNumber')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.phoneNumber),expression:"user.phoneNumber"}],attrs:{"type":"text","placeholder":_vm.$t('PhoneNumber')},domProps:{"value":(_vm.user.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "phoneNumber", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),(_vm.user.role != 'Server')?_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('AccessToSystems')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},_vm._l((_vm.access),function(sys,index){return _c('div',{key:index},[_vm._v(_vm._s(sys.systemName))])}),0)])]):_vm._e(),_vm._v(" "),(_vm.user.role != 'Server')?_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('AccessByGroups')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},_vm._l((_vm.sysGroups),function(sys,index){return _c('div',{key:index},[_vm._v(_vm._s(sys.name))])}),0)])]):_vm._e(),_vm._v(" "),_c('div',[(_vm.error != '')?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticStyle:{"align-self":"center"}},[_c('Button',{staticStyle:{"width":"300px","align-self":"center"},attrs:{"title":_vm.$t('Save'),"buttonClass":"save-button semi-bold"},on:{"onClick":_vm.save}})],1)]),_vm._v(" "),(_vm.user.role != 'Server')?_c('div',{staticStyle:{"display":"block"},attrs:{"id":"systems-container"}},[_c('h4',{staticStyle:{"padding-top":"10px"}},[_vm._v(_vm._s(_vm.$t('Systems')))]),_vm._v(" "),_c('div',{staticStyle:{"height":"44%","width":"90%","margin":"auto","padding":"0 0 10px 0"}},[_c('ejs-grid',{ref:"modal_grid",attrs:{"height":"100%","width":"100%","selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.systems,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"showBusyIndicator":true,"rowSelected":_vm.selectionChanged,"rowDeselected":_vm.selectionChanged}},[_c('e-columns',[_c('e-column',{attrs:{"type":"checkbox","width":"50","headerText":"Discontinued","textAlign":"Left"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"systemName","headerText":_vm.$t('SystemName').toUpperCase(),"textAlign":"Left"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"country","headerText":_vm.$t('Country').toUpperCase(),"textAlign":"Left","filter":_vm.filterCheckbox}})],1)],1)],1),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('Groups')))]),_vm._v(" "),_c('div',{staticStyle:{"height":"44%","width":"90%","margin":"auto","padding":"0 0 10px 0"}},[_c('ejs-grid',{ref:"groups_grid",attrs:{"height":"100%","width":"100%","selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.groups,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"showBusyIndicator":true,"rowSelected":_vm.groupsSelectionChanged,"rowDeselected":_vm.groupsSelectionChanged}},[_c('e-columns',[_c('e-column',{attrs:{"type":"checkbox","width":"50","headerText":"Discontinued","textAlign":"Left"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"name","headerText":_vm.$t('NAME'),"textAlign":"Left"}})],1)],1)],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1792:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PinModal_vue__ = __webpack_require__(1733);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4f3feb8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PinModal_vue__ = __webpack_require__(1795);
function injectStyle (ssrContext) {
  __webpack_require__(1793)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4f3feb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PinModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4f3feb8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PinModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1793:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1794);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("7a9f179d", content, true, {});

/***/ }),

/***/ 1794:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".error[data-v-c4f3feb8]{text-align:left!important;color:#fd8282;font-size:12px;font-weight:700;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Users/PinModal.vue"],"names":[],"mappings":"AACA,wBACE,0BAA4B,AAC5B,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,2CAAgD,AAChD,4BAA8B,AAC9B,yBAA4B,CAC7B","file":"PinModal.vue","sourcesContent":["\n.error[data-v-c4f3feb8] {\n  text-align: left !important;\n  color: #FD8282;\n  font-size: 12px;\n  font-weight: bold;\n  font-family: 'Open Sans', sans-serif !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-5 pr-5"},[_c('p',{staticClass:"mb-0 pt-4",staticStyle:{"text-align":"center","font-weight":"600","font-size":"18px"}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('PINtoConfirm')))]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pinNumber),expression:"pinNumber"}],attrs:{"type":"password","placeholder":_vm.$t('Pin')},domProps:{"value":(_vm.pinNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pinNumber=$event.target.value}}})]),_vm._v(" "),(_vm.error != '')?_c('div',{staticClass:"error",staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row d-flex justify-content-between pb-4 mt-4 ml-4 mr-4"},[_c('div',{staticClass:"col flex-grow pr-2"},[_c('Button',{attrs:{"title":_vm.$t('Cancel'),"buttonClass":"cancel-button semi-bold w-100"},on:{"onClick":_vm.cancel}})],1),_vm._v(" "),_c('div',{staticClass:"col flex-grow pl-2"},[_c('Button',{attrs:{"title":_vm.$t('Confirm'),"buttonClass":"save-button semi-bold w-100"},on:{"onClick":_vm.confirm}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1861:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Button__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__syncfusion_ej2_data__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__syncfusion_ej2_dropdowns__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Modal_vue__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Users_UserModal_vue__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_DeleteConfirm_vue__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Users_EditUserRole_vue__ = __webpack_require__(2145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Users_PinModal_vue__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Users_RestorePasswordModal_vue__ = __webpack_require__(2149);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















var context = null;

var LIST_SEPARATOR = ', ';

// Kolumny z listą nazw (systemy, grupy) – rekord pasuje, gdy lista zawiera wybraną nazwę.
// Filtr z wieloma wartościami grid łączy przez OR, więc wystarczy dopasowanie pojedynczej nazwy.
__WEBPACK_IMPORTED_MODULE_8__syncfusion_ej2_data__["b" /* DataUtil */].fnOperators.hasitem = function (actual, expected, ignoreCase) {
    if (actual == null || expected == null) return false;
    var list = LIST_SEPARATOR + actual + LIST_SEPARATOR;
    var item = LIST_SEPARATOR + expected + LIST_SEPARATOR;
    if (ignoreCase) {
        list = list.toLowerCase();
        item = item.toLowerCase();
    }
    return list.indexOf(item) !== -1;
};

function joinNames(items) {
    return (items || []).map(function (x) {
        return x.name;
    }).join(LIST_SEPARATOR);
}

function distinctNames(users, key) {
    var names = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a();
    users.forEach(function (u) {
        return (u[key] || []).forEach(function (x) {
            return names.add(x.name);
        });
    });
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(names).sort(function (a, b) {
        return a.localeCompare(b);
    });
}

function listFilter(getOptions) {
    var multiSelect = null;
    return {
        type: 'Menu',
        ui: {
            create: function create(args) {
                var operator = args.target.parentElement.querySelector('.e-flm_optrdiv');
                if (operator) operator.style.display = 'none';
                var input = document.createElement('input');
                args.target.appendChild(input);
                multiSelect = new __WEBPACK_IMPORTED_MODULE_9__syncfusion_ej2_dropdowns__["d" /* MultiSelect */]({
                    dataSource: getOptions(),
                    placeholder: context.$t('search'),
                    allowFiltering: true,
                    popupHeight: '250px'
                });
                multiSelect.appendTo(input);
            },
            write: function write(args) {
                var selected = args.parent.filterSettings.columns.filter(function (c) {
                    return c.field === args.column.field;
                }).map(function (c) {
                    return c.value;
                });
                multiSelect.value = selected.length ? selected : null;
            },
            read: function read(args) {
                args.fltrObj.removeFilteredColsByField(args.column.field);
                var values = multiSelect.value || [];
                if (values.length) args.fltrObj.filterByColumn(args.column.field, 'hasitem', values);
            }
        }
    };
}

function ellipsisTemplate(field) {
    return function () {
        return {
            template: __WEBPACK_IMPORTED_MODULE_13_vue__["default"].component('ellipsisTemplate_' + field, {
                template: '\n                    <div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden !important;">{{ data.' + field + ' }}</div>\n                ',
                data: function data() {
                    return {
                        data: {}
                    };
                }
            })
        };
    };
}

/* harmony default export */ __webpack_exports__["b"] = ({
    props: {},
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_7__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_7__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_7__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_7__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_7__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_7__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_7__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_7__syncfusion_ej2_vue_grids__["f" /* ExcelExport */]]
    },
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_5__components_Button__["a" /* default */],
        Modal: __WEBPACK_IMPORTED_MODULE_10__components_Modal_vue__["a" /* default */],
        UserModal: __WEBPACK_IMPORTED_MODULE_11__components_Users_UserModal_vue__["a" /* default */],
        DeleteConfirm: __WEBPACK_IMPORTED_MODULE_12__components_DeleteConfirm_vue__["a" /* default */],
        EditUserRole: __WEBPACK_IMPORTED_MODULE_14__components_Users_EditUserRole_vue__["a" /* default */],
        PinModal: __WEBPACK_IMPORTED_MODULE_15__components_Users_PinModal_vue__["a" /* default */],
        RestorePasswordModal: __WEBPACK_IMPORTED_MODULE_16__components_Users_RestorePasswordModal_vue__["a" /* default */]
    },
    data: function data() {
        var _this = this;

        return {
            users: [],
            activeModal: 'NONE',
            activeUser: null,
            deleteText: '',

            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [{ text: this.$t('Users'), align: 'Left', id: 'table-title' }, { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right' }, { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export' }, { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export' }, { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export' }, { text: this.$t('AddUser'), tooltipText: 'Add User', prefixIcon: 'e-add', id: 'addUser', align: 'Right' }, 'Search'],
            wrapSettings: { wrapMode: 'Content' },
            selectionOptions: { type: 'Multiple' },
            filterOptions: {
                type: 'Menu'
            },
            filterCheckBox: {
                type: 'CheckBox'
            },
            sortOptions: {
                columns: [{ field: 'role', direction: 'Ascending' }]
            },
            customAttributes: { class: 'customcss' },
            optionsTemplate: function optionsTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_13_vue__["default"].component('optionsTemplate', {
                        template: '\n                            <div class="horizontal grow">\n                                <div class="" style="cursor: pointer; margin: 5px" v-on:click="onClick(\'PASSWORD\')" content="' + context.$t('Password') + '" v-tippy="{ theme : \'customTheme\', placement : \'left\', arrow : true }">\n                                    <svg width="27" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.6667 8.99988L12 11.9999M12 11.9999L10.3333 8.99988M12 11.9999H9.5M12 11.9999H14.5M12 11.9999L10.3333 14.9999M12 11.9999L13.6667 14.9999M6.16667 8.99994L4.5 11.9999M4.5 11.9999L2.83333 8.99994M4.5 11.9999H2M4.5 11.9999H7M4.5 11.9999L2.83333 14.9999M4.5 11.9999L6.16667 14.9999M21.1667 8.99994L19.5 11.9999M19.5 11.9999L17.8333 8.99994M19.5 11.9999H17M19.5 11.9999H22M19.5 11.9999L17.8333 14.9999M19.5 11.9999L21.1667 14.9999" stroke="#346F8B" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>\n                                </div>\n                                <div class="" style="cursor: pointer; margin: 5px" v-on:click="onClick(\'EDIT\')" content="' + context.$t('Edit') + '" v-tippy="{ theme : \'customTheme\', placement : \'left\', arrow : true }">\n                                    <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.64951 16.4004L7.64952 16.4003M7.64951 16.4004L7.64951 16.4004L7.64952 16.4003M7.64951 16.4004C7.64952 16.4004 7.64952 16.4003 7.64952 16.4003M7.64951 16.4004L7.64952 16.4003M14.95 7.25429L17.4952 9.61783L10.5666 16.0519L7.66216 16.3496L7.66203 16.3496C7.65971 16.3499 7.65755 16.35 7.65555 16.35L7.96842 13.737L14.95 7.25429ZM18.5296 4.83337L20.1732 6.35962C20.4089 6.57848 20.4091 6.91217 20.1731 7.13143L19.0692 8.15645L16.524 5.79293L17.5573 4.83337C17.8206 4.58888 18.2663 4.58888 18.5296 4.83337Z" stroke="#346F8B" stroke-width="1.3"/></svg>\n                                </div>\n                                <div class="" style="cursor: pointer; margin: 5px" v-on:click="onClick(\'DELETE\')" content="' + context.$t('Delete') + '" v-tippy="{ theme : \'customTheme\', placement : \'left\', arrow : true }">\n                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 1.4C3.5 0.626801 4.1268 0 4.9 0H9.1C9.8732 0 10.5 0.626801 10.5 1.4V2.8H11.8928C11.8971 2.79996 11.9014 2.79996 11.9058 2.8H13.3C13.6866 2.8 14 3.1134 14 3.5C14 3.8866 13.6866 4.2 13.3 4.2H12.5518L11.9447 12.6997C11.8923 13.4324 11.2827 14 10.5482 14H3.45178C2.71729 14 2.10767 13.4324 2.05534 12.6997L1.44822 4.2H0.7C0.313401 4.2 0 3.8866 0 3.5C0 3.1134 0.313401 2.8 0.7 2.8H2.09422C2.09856 2.79996 2.1029 2.79996 2.10722 2.8H3.5V1.4ZM4.9 2.8H9.1V1.4H4.9V2.8ZM2.85178 4.2L3.45178 12.6H10.5482L11.1482 4.2H2.85178ZM5.6 5.6C5.9866 5.6 6.3 5.9134 6.3 6.3V10.5C6.3 10.8866 5.9866 11.2 5.6 11.2C5.2134 11.2 4.9 10.8866 4.9 10.5V6.3C4.9 5.9134 5.2134 5.6 5.6 5.6ZM8.4 5.6C8.7866 5.6 9.1 5.9134 9.1 6.3V10.5C9.1 10.8866 8.7866 11.2 8.4 11.2C8.0134 11.2 7.7 10.8866 7.7 10.5V6.3C7.7 5.9134 8.0134 5.6 8.4 5.6Z" fill="#346F8B"/></svg>\n                                </div>\n                            </div>\n\n                        ',
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        methods: {
                            onClick: function onClick(mode) {
                                switch (mode) {
                                    case 'EDIT':
                                        context.openModal(this.data, 'EDIT');
                                        break;
                                    case 'DELETE':
                                        context.openModal(this.data, 'DELETE');
                                        break;
                                    case 'PASSWORD':
                                        context.openModal(this.data, 'SHOW_PASSWORD_PIN');
                                        break;
                                }
                            }
                        }
                    })
                };
            },
            systemsFilter: listFilter(function () {
                return distinctNames(_this.users, 'systems');
            }),
            systemGroupsFilter: listFilter(function () {
                return distinctNames(_this.users, 'systemGroups');
            }),
            systemsTemplate: ellipsisTemplate('systemsText'),
            systemGroupsTemplate: ellipsisTemplate('systemGroupsText')
        };
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var result;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this2.$store.dispatch('set_loading', true);
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_6__api__["_93" /* getUserSystems */])();

                            case 3:
                                result = _context.sent;

                                _this2.users = result.map(function (u) {
                                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, u, {
                                        systemsText: joinNames(u.systems),
                                        systemGroupsText: joinNames(u.systemGroups)
                                    });
                                });
                                _this2.$store.dispatch('set_loading', false);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        deleteUser: function deleteUser() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_6__api__["D" /* deleteUser */])(_this3.activeUser.id);

                            case 2:
                                _this3.getData();
                                _this3.closeModal();

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        openModal: function openModal(user, mode) {
            this.activeUser = user;
            this.deleteText = this.$t('Delete') + ' ' + (this.activeUser != null ? this.activeUser.fullName : '');
            this.activeModal = mode;
        },
        closeModal: function closeModal(mode) {
            this.activeUser = null;
            this.activeModal = 'NONE';
            if (mode == 'getData') this.getData();
        },
        closePinModal: function closePinModal() {
            this.activeModal = 'SHOW_RESET_PASSWORD_MODAL';
        },


        toolbarClick: function toolbarClick(args) {
            switch (args.item.id) {
                case 'addUser':
                    this.openModal(null, 'ADD');
                    break;
                case 'table-title':
                    this.getData();
                    break;
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        },
        dataBound: function dataBound() {
            this.$refs.grid.autoFitColumns();
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return this.getData();

                        case 2:

                            context = this;

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1862:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TextField__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Button__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(952);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['id'],
    watch: {},
    methods: {
        getData: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _this = this;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_43" /* getRoles */])();

                            case 2:
                                this.roles = _context.sent;
                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_89" /* getUserById */])(this.id);

                            case 5:
                                this.user = _context.sent;

                                if (this.user.roles.length != 0) {
                                    this.selectedRole = this.roles.find(function (m) {
                                        return m.name === _this.user.roles[0];
                                    });
                                }

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getData() {
                return _ref.apply(this, arguments);
            }

            return getData;
        }(),
        cancel: function cancel() {
            this.$emit('cancel');
        },
        save: function save() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this2.selectedRole == null)) {
                                    _context2.next = 5;
                                    break;
                                }

                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_105" /* removeUserRoles */])(_this2.id);

                            case 3:
                                _context2.next = 7;
                                break;

                            case 5:
                                _context2.next = 7;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_129" /* updateUserRole */])(_this2.id, _this2.selectedRole.name);

                            case 7:

                                _this2.$emit('save');

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },
    computed: {
        farmId: function farmId() {}
    },
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_3__components_Button__["a" /* default */],
        TextField: __WEBPACK_IMPORTED_MODULE_2__components_TextField__["a" /* default */]
    },
    mounted: function mounted() {
        this.getData();
    },
    data: function data() {
        return {
            user: {},
            roles: [],
            selectedRole: null
        };
    }
});

/***/ }),

/***/ 1863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Button__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api__ = __webpack_require__(952);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['text', 'email'],
    data: function data() {
        return {
            pwd: '',
            error: ''
        };
    },
    methods: {
        confirm: function confirm() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var err;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.error = '';

                                if (!(_this.pwd == null || _this.pwd.length == 0)) {
                                    _context.next = 5;
                                    break;
                                }

                                _this.error = 'Required';
                                _context.next = 17;
                                break;

                            case 5:
                                _this.error = '';
                                _context.prev = 6;
                                _context.next = 9;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_106" /* restorePassword */])({ Email: _this.email.email, NewPassword: _this.pwd, OldPassword: _this.pwd, ConfirmNewPassword: _this.pwd });

                            case 9:
                                _this.$emit('confirm');
                                _context.next = 17;
                                break;

                            case 12:
                                _context.prev = 12;
                                _context.t0 = _context['catch'](6);

                                // console.log({ex})
                                err = _context.t0.response.data.errors;

                                _this.error = '';
                                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(err).forEach(function (e) {
                                    err[e].forEach(function (el) {
                                        _this.error += el + '\n';
                                    });
                                });

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[6, 12]]);
            }))();
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    },
    computed: {},
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_3__components_Button__["a" /* default */]
    }
});

/***/ }),

/***/ 2141:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2142);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("45c73a03", content, true, {});

/***/ }),

/***/ 2142:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".table[data-v-0a85f8d9]{border-top:none;border-left:none;border-right:none}.table tbody[data-v-0a85f8d9]{border-left:1px solid #a3d4e0;border-right:1px solid #a3d4e0}.e-grid .e-headercell.customcss[data-v-0a85f8d9]{padding:0 5px}.e-grid .e-headercell .e-headercelldiv[data-v-0a85f8d9]{padding-right:5px}.e-gridchkbox.customcss .e-checkbox-wrapper[data-v-0a85f8d9]{vertical-align:middle}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Users/Users.vue"],"names":[],"mappings":"AACA,wBACI,gBAAiB,AACjB,iBAAkB,AAClB,iBAAmB,CACtB,AACD,8BACI,8BAA+B,AAC/B,8BAAgC,CACnC,AACD,iDACI,aAAoB,CACvB,AACD,wDACI,iBAAkB,CACrB,AACD,6DACI,qBAAuB,CAC1B","file":"Users.vue","sourcesContent":["\n.table[data-v-0a85f8d9] {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n}\n.table tbody[data-v-0a85f8d9]{\n    border-left: 1px solid #A3D4E0;\n    border-right: 1px solid #A3D4E0;\n}\n.e-grid .e-headercell.customcss[data-v-0a85f8d9]{\n    padding:0 5px 0 5px;\n}\n.e-grid .e-headercell .e-headercelldiv[data-v-0a85f8d9]{\n    padding-right:5px;\n}\n.e-gridchkbox.customcss .e-checkbox-wrapper[data-v-0a85f8d9]{\n    vertical-align: middle;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2143:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2144);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("4e6a0456", content, true, {});

/***/ }),

/***/ 2144:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tippy-tooltip.customTheme-theme{background-color:#346f8b}.tippy-popper[x-placement^=left] .tippy-tooltip.customTheme-theme .tippy-arrow{border-left:8px solid #346f8b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Users/Users.vue"],"names":[],"mappings":"AACA,iCACE,wBAA0B,CAC3B,AACD,+EACE,6BAA+B,CAChC","file":"Users.vue","sourcesContent":["\n.tippy-tooltip.customTheme-theme {\n  background-color: #346F8B;\n}\n.tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {\n  border-left: 8px solid #346F8B;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserRole_vue__ = __webpack_require__(1862);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_283cc0da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserRole_vue__ = __webpack_require__(2148);
function injectStyle (ssrContext) {
  __webpack_require__(2146)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-283cc0da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserRole_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_283cc0da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserRole_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2146:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2147);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("1d999af6", content, true, {});

/***/ }),

/***/ 2147:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "select[data-v-283cc0da]{padding-left:.5rem}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Users/EditUserRole.vue"],"names":[],"mappings":"AACA,wBACI,kBAAqB,CACxB","file":"EditUserRole.vue","sourcesContent":["\nselect[data-v-283cc0da] {\n    padding-left: 0.5rem;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TextField',{attrs:{"inputClass":"form-input","title":"E-mail","disabled":true},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}}),_vm._v(" "),_c('p',{staticClass:"title mt-3"},[_vm._v("Role")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRole),expression:"selectedRole"}],staticClass:"form-input mb-3",staticStyle:{"border-radius":"5px"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedRole=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.roles),function(role){return _c('option',{domProps:{"value":role}},[_vm._v("\n      "+_vm._s(role.name)+"\n     ")])})],2),_vm._v(" "),_c('div',{staticClass:"row d-flex justify-content-between pb-5 mt-4"},[_c('div',{staticClass:"col flex-grow pr-1"},[_c('Button',{attrs:{"title":"Cancel","buttonClass":"cancel-button semi-bold w-100"},on:{"onClick":_vm.cancel}})],1),_vm._v(" "),_c('div',{staticClass:"col flex-grow pl-1"},[_c('Button',{attrs:{"title":"Save","buttonClass":"save-button semi-bold w-100"},on:{"onClick":_vm.save}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestorePasswordModal_vue__ = __webpack_require__(1863);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e2f3e90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestorePasswordModal_vue__ = __webpack_require__(2152);
function injectStyle (ssrContext) {
  __webpack_require__(2150)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestorePasswordModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e2f3e90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestorePasswordModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2150:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2151);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("0188225a", content, true, {});

/***/ }),

/***/ 2151:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"RestorePasswordModal.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-5 pr-5"},[_c('p',{staticClass:"mb-0 pt-4",staticStyle:{"text-align":"center","font-weight":"600","font-size":"18px"}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('PasswordToConfirm')))]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pwd),expression:"pwd"}],attrs:{"type":"password","placeholder":_vm.$t('NewPassword')},domProps:{"value":(_vm.pwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pwd=$event.target.value}}})]),_vm._v(" "),(_vm.error != '')?_c('div',{staticClass:"error",staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row d-flex justify-content-between pb-4 mt-4 ml-4 mr-4"},[_c('div',{staticClass:"col flex-grow pr-2"},[_c('Button',{attrs:{"title":_vm.$t('Cancel'),"buttonClass":"cancel-button semi-bold w-100"},on:{"onClick":_vm.cancel}})],1),_vm._v(" "),_c('div',{staticClass:"col flex-grow pl-2"},[_c('Button',{attrs:{"title":_vm.$t('Confirm'),"buttonClass":"save-button semi-bold w-100"},on:{"onClick":_vm.confirm}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('modal',{attrs:{"showDialog":_vm.activeModal === 'ADD',"title":_vm.$t('AddUser').toUpperCase()},on:{"close":_vm.closeModal}},[_c('user-modal',{on:{"cancel":_vm.closeModal,"save":function($event){return _vm.closeModal('getData')}}})],1),_vm._v(" "),_c('modal',{attrs:{"showDialog":_vm.activeModal === 'EDIT',"title":_vm.$t('EditUser').toUpperCase()},on:{"close":_vm.closeModal}},[_c('user-modal',{attrs:{"userObj":_vm.activeUser},on:{"cancel":_vm.closeModal,"save":function($event){return _vm.closeModal('getData')}}})],1),_vm._v(" "),_c('modal',{attrs:{"showDialog":_vm.activeModal === 'DELETE',"title":_vm.$t('DeleteUser').toUpperCase()},on:{"close":_vm.closeModal}},[_c('delete-confirm',{attrs:{"text":_vm.deleteText},on:{"cancel":_vm.closeModal,"confirm":_vm.deleteUser}})],1),_vm._v(" "),_c('modal',{attrs:{"showDialog":_vm.activeModal === 'SHOW_PASSWORD_PIN',"title":_vm.$t('INSERT_PIN')},on:{"close":_vm.closeModal}},[_c('pin-modal',{attrs:{"text":_vm.$t('enterPin'),"actionType":'SHOW_PASSWORD'},on:{"cancel":_vm.closeModal,"confirm":_vm.closePinModal}})],1),_vm._v(" "),_c('modal',{attrs:{"showDialog":_vm.activeModal === 'SHOW_RESET_PASSWORD_MODAL',"title":_vm.$t('RESET_PASSWORD')},on:{"close":_vm.closeModal}},[_c('restore-password-modal',{attrs:{"email":_vm.activeUser,"text":_vm.$t('reset_password')},on:{"cancel":_vm.closeModal,"confirm":_vm.closeModal}})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"100%","overflow-x":"auto"}},[_c('div',{staticClass:"max-grid"},[_c('ejs-grid',{ref:"grid",attrs:{"height":"100%","width":"100%","toolbar":_vm.$store.getters.isAdmin ? _vm.toolbar : null,"toolbarClick":_vm.toolbarClick,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.users,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"sortSettings":_vm.sortOptions,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true}},[_c('e-columns',[_c('e-column',{attrs:{"field":"fullName","headerText":_vm.$t('UserName'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"email","headerText":_vm.$t('Email'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"role","headerText":_vm.$t('Role'),"textAlign":"Left","customAttributes":_vm.customAttributes,"filter":_vm.filterCheckBox,"width":"200px"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"systemsText","type":"string","headerText":_vm.$t('AccessToSystem'),"textAlign":"Left","template":_vm.systemsTemplate,"customAttributes":_vm.customAttributes,"filter":_vm.systemsFilter}}),_vm._v(" "),_c('e-column',{attrs:{"field":"systemGroupsText","type":"string","headerText":_vm.$t('SystemGroups'),"textAlign":"Left","template":_vm.systemGroupsTemplate,"customAttributes":_vm.customAttributes,"filter":_vm.systemGroupsFilter}}),_vm._v(" "),(_vm.$store.getters.isAdmin)?_c('e-column',{attrs:{"field":"id","headerText":"","width":"150px","allowSorting":false,"allowFiltering":false,"template":_vm.optionsTemplate}}):_vm._e()],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.a0c26579e32a10005313.js